import User from "../../../model/User";
import { UUID } from "../../../utils/typeDefinitions";
import IDocumentProvider from "../../documentProvider/IDocumentProvider";
import IBimVisualizerApiProvider from "../IBimVisualizerApiProvider";
import AppDataProvider from "./AppDataProvider";

export default abstract class StartupProjectApiDataLoader extends AppDataProvider  {
    projectGlobalId: UUID;

    constructor(apiProvider: IBimVisualizerApiProvider, docProvider: IDocumentProvider, projectGlobalId: UUID) {
        super(apiProvider, docProvider);
        this.projectGlobalId = projectGlobalId;
    }

    // For now, there is no auth or user when using bim models
    getCurrentUser = async (): Promise<User | null> => {
        throw new Error("Method not implemented.");
    }
}